export enum ValidationDisplayType {
    StandardValidation,
    StyledValidation,
}
